import React from 'react';
import { usePageContent } from '../services/contentService';
import LoadingOverlay from '../components/LoadingOverlay';
import Hero from '../components/Hero';
import FromIdeaToImpact from '../components/FromIdeaToImpact';
import WhatWeDo from '../components/WhatWeDo';
import ImpactStories from '../components/ImpactStories';
import Partnership from '../components/Partnership';
import CallToAction from '../components/CallToAction';
import SEO from '../components/SEO';

const Home = () => {
  const { content, loading, error } = usePageContent('home');

  if (loading || !content) {
    return <LoadingOverlay />;
  }

  if (error) {
    console.warn('Content loading error:', error);
    // Fall back to static content if there's an error
  }

  return (
    <div className="home-page">
      <SEO
        title="Home"
        description="YOCILAB - Empowering young Africans with skills, networks, and funding to design solutions that create jobs and scale impact."
      />
      <Hero content={content} />
      <FromIdeaToImpact content={content} />
      <WhatWeDo content={content} />
      <ImpactStories content={content} />
      <Partnership content={content} />
      <CallToAction content={content} />
    </div>
  );
};

export default Home;